import { PageLayout } from '@bpm-web-app/components';
import { ArtistFeaturedIn } from '@bpm-web-app/components/pages';

const ArtistFeaturedInPage = () => (
    <PageLayout>
        <ArtistFeaturedIn />
    </PageLayout>
);

export default ArtistFeaturedInPage;
